import { useContext, useEffect } from 'react'
import { NavContext } from '../../../../context/global_context'
import {
  CustomerContext,
  SET_SELECTED_CUSTOMER_DATA,
  SHOW_CUSTOMER_FORM,
  UPDATE_CHANGE_CUSTOMER_DATA,
} from '../context/context'
import { postRequest, putRequest } from '../../../../services/base'
import Modal, { ModalBody, ModalHeader } from '../../../common/Modal'
import InputText from '../../../common/InputText'
import TextArea from '../../../common/TextArea'
import Button from '../../../common/Button'
import { getLocalStorageData } from '../../../../utils/LocalStorageAccess'
import { MAKE_ID } from '../../../../constants/common'

const CustomerForm = ({ getCustomerData = () => {} }) => {
  const [navState, navDispatch] = useContext(NavContext)
  const [state, dispatch] = useContext(CustomerContext)

  useEffect(() => {
    dispatch({
      type: SET_SELECTED_CUSTOMER_DATA,
      data: {
        ...state?.selectedObject,
        make: getLocalStorageData(MAKE_ID),
      },
      showFormPopup: true,
    })
  }, [])

  const saveCustomer = async (e) => {
    navDispatch({
      type: 'loader',
      data: {
        caption: `Saving Customer.`,
        showLoader: true,
      },
      notification: {},
    })

    const form = e.target
    const formData = new FormData(form)
    if (state?.selectedObject?.id) {
      let res = await putRequest(
        `/api/customer/${state?.selectedObject?.id}/`,
        formData
      )

      if (res?.status) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'Customer Updated Successfully',
          },
        })
        dispatch({
          type: UPDATE_CHANGE_CUSTOMER_DATA,
          data: state?.selectedObject,
        })
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
          },
        })
      }
    } else {
      let res = await postRequest(`/api/customer/`, formData)
      getCustomerData()
      if (res?.status) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'Customer Saved Successfully',
          },
        })
        dispatch({ type: SHOW_CUSTOMER_FORM, data: {}, showFormPopup: false })
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
          },
        })
      }
    }
  }

  return (
    <Modal
      onClose={() => {
        dispatch({ type: SHOW_CUSTOMER_FORM, data: {}, showFormPopup: false })
      }}
      show={state.showFormPopup}
    >
      <ModalHeader className={'text-white'}>
        {state?.selectedObject?.id
          ? 'Update Existing Customer'
          : 'Create New Customer'}
      </ModalHeader>
      <ModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            saveCustomer(e)
          }}
        >
          <input
            type="hidden"
            value={state?.selectedObject?.id ? false : true}
            name="is_create"
          />
          {state?.selectedObject?.id && (
            <input type="hidden" name="id" value={state?.selectedObject?.id} />
          )}
          <InputText
            name="name"
            type="text"
            label="Customer Name"
            value={state?.selectedObject?.name}
            onChange={(value) => {
              dispatch({
                type: SET_SELECTED_CUSTOMER_DATA,
                data: {
                  ...state?.selectedObject,
                  name: value,
                },
                showFormPopup: true,
              })
            }}
          />
          <InputText
            name="make"
            type="text"
            label="Customer Make"
            value={state?.selectedObject?.make}
            onChange={(value) => {
              dispatch({
                type: SET_SELECTED_CUSTOMER_DATA,
                data: {
                  ...state?.selectedObject,
                  make: value,
                },
                showFormPopup: true,
              })
            }}
            readOnly={getLocalStorageData(MAKE_ID) ? true : false}
          />

          <InputText
            name="business_timezone"
            type="text"
            label="Customer Business Timezone"
            value={state?.selectedObject?.business_timezone}
            onChange={(value) => {
              dispatch({
                type: SET_SELECTED_CUSTOMER_DATA,
                data: {
                  ...state?.selectedObject,
                  business_timezone: value,
                },
                showFormPopup: true,
              })
            }}
            isRequired={false}
          />

          <TextArea
            label={`Vin Dependent Make Model Tags`}
            name="vin_dependent_make_model_tags"
            value={state?.selectedObject?.vin_dependent_make_model_tags}
            isRequired={false}
            className={'w-full'}
            wrapperClass="text-white p-2"
            onChange={(value) => {
              dispatch({
                type: SET_SELECTED_CUSTOMER_DATA,
                data: {
                  ...state?.selectedObject,
                  vin_dependent_make_model_tags: value,
                },
                showFormPopup: true,
              })
            }}
          />

          <div className="flex justify-end">
            <div>
              <Button
                type="submit"
                className={`cursor-pointer btn my-4 px-2 w-full justify-end`}
                onClick={(e) => {}}
                value={'text'}
                text={
                  state?.selectedObject?.id
                    ? 'Save Customer'
                    : 'Create New Customer'
                }
              />
            </div>
          </div>
        </form>
      </ModalBody>
    </Modal>
  )
}

export default CustomerForm
